import { useSpace } from 'src/hooks/useSpace';
import { useWorkspaceLocations } from 'src/hooks/useWorkspaceLocations';

const useWorkspaceMember = () => {
  const { member } = useSpace();
  const locations = useWorkspaceLocations();

  const getLocationName = () => {
    if (locations.length === 0 || !member?.location) return '';

    return (
      locations.find((location) => location._id === member.location)?.name ?? ''
    );
  };

  const role = member.roles[0];
  const locationId = member?.location;
  const locationName = getLocationName();

  return { role, locationId, locationName };
};

export default useWorkspaceMember;
